import balanceJson from "./tables/frontline/balance.json";
import abilitiesJson from "./tables/frontline/abilities.json";
import evolutionJson from "./tables/frontline/evolution.json";
import skillsJson from "./tables/frontline/skills.json";
import viewJson from "./tables/presentation/frontline-view.json";

export type FrontlineBalance = typeof balanceJson;
export type FrontlineAbilities = typeof abilitiesJson;
export type FrontlineEvolution = typeof evolutionJson;
export type FrontlineSkills = typeof skillsJson;
export type FrontlineViewTable = typeof viewJson;

export const frontlineCatalog = {
  balance: balanceJson as FrontlineBalance,
  abilities: abilitiesJson as FrontlineAbilities,
  evolution: evolutionJson as FrontlineEvolution,
  skills: skillsJson as FrontlineSkills,
  view: viewJson as FrontlineViewTable,
} as const;

export function hexToColor(hex: string): number {
  const s = hex.replace("#", "").slice(0, 6);
  return Number.parseInt(s, 16);
}

/** Unit/HQ HP fill keyed by team (0 ally, 1 enemy). */
export function hpBarColorForTeam(team: 0 | 1): number {
  const c = frontlineCatalog.view.colors;
  return hexToColor(team === 0 ? c.hpBarAlly : c.hpBarEnemy);
}
